/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/PaymentMethodEvent.php */
export const paymentMethodEvent = {
	Updated: 'updated',
	PrimaryChanged: 'primary-changed',
	Deleted: 'deleted',
} as const

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/PaymentMethodEvent.php */
export type PaymentMethodEvent = (typeof paymentMethodEvent)[keyof typeof paymentMethodEvent]
